import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from './container/header'
import Footer from './container/footer'

const Layout = () => {
    return (
        <div>
            <Header />
            <div className='bg-[#F5F6FA] p-[50px]'>
                <Outlet />
            </div>
            <Footer />
        </div>
    )
}

export default Layout
